<nav class="navbar navbar-expand-sm navbar-dark bg-success">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" class="navbar-brand">{{ "title" | translate }}</a>
    </div>

    <ul class="navbar-nav">
      <li class="nav-item">
        <a href="#" class="nav-link" (click)="onUseLanguage('en')">EN</a>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" (click)="onUseLanguage('ru')">RU</a>
      </li>
    </ul>
  </div>
</nav>
